import { UserWorkoutSession } from '../../workoutsession/userworkoutsession';
import { GymState } from '../gymstate';
import { IGymSchedule } from '../igymschedule';

export class SyncedGymSchedule implements IGymSchedule {
  public size: number;
  public lastKeepaliveTime: Date;
  public readonly sessions: UserWorkoutSession[] = [];

  private readonly amountOfStationsAtGym: number;

  // db is any here, since this is currently used in the simulator (browser) and gym server (node)
  // ie, pouchdb and pouchdb-node
  constructor(amountOfStationsAtGym: number, cycleTimeInSeconds: number, private db: any) {
    this.amountOfStationsAtGym = amountOfStationsAtGym;
  }

  public amountOfStations(): number {
    return this.amountOfStationsAtGym;
  }

  public setState(cycleTime: number, state: GymState): Promise<void> {
    const doc = JSON.parse(JSON.stringify(state));
    doc._id = cycleTime + '';
    return this.db.put(doc);
  }

  public getState(cycleTime: number): Promise<GymState> {
    const id = cycleTime + '';
    return this.db.get(id);
  }

  public hasState(cycleTime: number): Promise<boolean> {
    return this.getState(cycleTime)
      .then(() => true)
      .catch((err: Error) => err.message.match(/not found/i) !== null);
  }

  public getAll(): Promise<Map<number, GymState>> {
    return this.db.allDocs({ include_docs: true })
      .then((result: any) => result.rows)
      .then((rows: any[]) => rows.map((row) => row.doc));
  }
}
